import React, {useContext} from 'react'
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {Checkbox, Form} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const OfferUpdateGift = ({rowIndex, record}) => {

    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    const onChange = ({target}) => {
        target.checked ? onChecked() : onUnChecked()
    }

    const onChecked = () => {
        const generateList = replaceIndexAt(
            bidList,
            {
                ...record,
                gift: true,
                linePrice: 0
            },
            rowIndex
        )
        setBidList(generateList)
    }

    const onUnChecked = () => {
        const generateList = replaceIndexAt(
            bidList,
            {
                ...record,
                gift: false
            },
            rowIndex
        )
        setBidList(generateList)
    }

    return(
        <React.Fragment>
            <Form>
                <Form.Item>
                    <Checkbox key={`offer-update-gift-${rowIndex}`} onChange={onChange} checked={record.gift}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateGift